import { addDays, startOfDay } from 'date-fns';
import {
  useListCalendarItems,
  useListCalendarItemsQueryParams,
} from './useListCalendarItems';

interface Params {
  date: string;
  params?: useListCalendarItemsQueryParams;
}

/** Gets the next calender */
export const useTodaysCalendarItems = ({ params, date }: Params) => {
  return useListCalendarItems({
    params: {
      habitatID: params?.habitatID as string,
      filter: {
        from: startOfDay(new Date(date)).toISOString(),
        to: startOfDay(addDays(new Date(date), 1)).toISOString(),
      },
    },
  });
};
